import { fontFamily, spacing, colors, primitiveColors, radius } from '../../theming';

export const styles = {
    container: {
        padding: `${spacing[4]} ${spacing[5]}`,
        maxWidth: '1084px',
        margin: '0 auto',
    },
    mainTitle: {
        fontFamily: fontFamily.first,
        letterSpacing: '0.20em',
        fontWeight: 700,
        fontSize: 24,
        textTransform: 'uppercase',
        color: colors.colorSecondary,
    },
    updateDate: {
        fontFamily: fontFamily.first,
        fontSize: 14,
        fontWeight: 500,
        letterSpacing: '0.05em',
        color: colors.colorSecondary,
    },
    sectionTitle: {
        fontFamily: fontFamily.first,
        fontSize: 20,
        color: colors.colorSecondary,
        letterSpacing: '0.05em',
    },
    paragraph: {
        fontFamily: fontFamily.first,
        lineHeight: '24px',
        fontSize: 16,
        color: colors.colorSecondary,
    },
    text: {
        fontFamily: fontFamily.first,
        fontSize: 16,
        lineHeight: '24px',
        color: colors.colorSecondary,
    },
    list: {
        fontFamily: fontFamily.first,
        fontSize: 16,
        color: colors.colorSecondary,
        letterSpacing: '0.025em',
    },
    listItemMeta: {
        fontWeight: 'normal',
    },
    bullet: {
        color: primitiveColors.main,
    },
    button: {
        backgroundColor: primitiveColors.main,
        color: primitiveColors.gray0,
        fontFamily: fontFamily.first,
        borderRadius: radius.huge,
        '&:hover': {
            backgroundColor: colors.colorPrimary,
        },
    },
};

export const getPrivacyData = t => {
    return {
        backToLogin: t('backToLogin'),
        intro: {
            title: t('privacy.intro.title'),
            text: t('privacy.intro.text'),
        },
        personalData: {
            title: t('privacy.personalData.title'),
            text: t('privacy.personalData.text'),
            list: [
                {
                    title: t('privacy.personalData.list.0.title'),
                    text: t('privacy.personalData.list.0.text'),
                },
                {
                    title: t('privacy.personalData.list.1.title'),
                    text: t('privacy.personalData.list.1.text'),
                },
                {
                    title: t('privacy.personalData.list.2.title'),
                    text: t('privacy.personalData.list.2.text'),
                },
            ],
        },
        purposeOfProcessing: {
            title: t('privacy.purposeOfProcessing.title'),
            text: t('privacy.purposeOfProcessing.text'),
            list: [
                {
                    title: t('privacy.purposeOfProcessing.list.0.title'),
                    text: t('privacy.purposeOfProcessing.list.0.text'),
                },
                {
                    title: t('privacy.purposeOfProcessing.list.1.title'),
                    text: t('privacy.purposeOfProcessing.list.1.text'),
                },
                {
                    title: t('privacy.purposeOfProcessing.list.2.title'),
                    text: t('privacy.purposeOfProcessing.list.2.text'),
                },
                {
                    title: t('privacy.purposeOfProcessing.list.3.title'),
                    text: t('privacy.purposeOfProcessing.list.3.text'),
                },
                {
                    title: t('privacy.purposeOfProcessing.list.4.title'),
                    text: t('privacy.purposeOfProcessing.list.4.text'),
                },
            ],
        },
        transferOfData: {
            title: t('privacy.transferOfData.title'),
            text: t('privacy.transferOfData.text'),
            list: [
                {
                    title: t('privacy.transferOfData.list.0.title'),
                    text: t('privacy.transferOfData.list.0.text'),
                },
                {
                    title: t('privacy.transferOfData.list.1.title'),
                    text: t('privacy.transferOfData.list.1.text'),
                },
                {
                    title: t('privacy.transferOfData.list.2.title'),
                    text: t('privacy.transferOfData.list.2.text'),
                },
                {
                    title: t('privacy.transferOfData.list.3.title'),
                    text: t('privacy.transferOfData.list.3.text'),
                },
            ],
        },
        rights: {
            title: t('privacy.rights.title'),
            text: t('privacy.rights.text'),
            list: [
                {
                    title: t('privacy.rights.list.0.title'),
                    text: t('privacy.rights.list.0.text'),
                },
                {
                    title: t('privacy.rights.list.1.title'),
                    text: t('privacy.rights.list.1.text'),
                },
                {
                    title: t('privacy.rights.list.2.title'),
                    text: t('privacy.rights.list.2.text'),
                },
            ],
        },
        storagePeriod: {
            title: t('privacy.storagePeriod.title'),
            text: t('privacy.storagePeriod.text'),
        },
        security: {
            title: t('privacy.security.title'),
            text: t('privacy.security.text'),
            list: [
                {
                    title: t('privacy.security.list.0.title'),
                    text: t('privacy.security.list.0.text'),
                },
                {
                    title: t('privacy.security.list.1.title'),
                    text: t('privacy.security.list.1.text'),
                },
                {
                    title: t('privacy.security.list.2.title'),
                    text: t('privacy.security.list.2.text'),
                },
                {
                    title: t('privacy.security.list.3.title'),
                    text: t('privacy.security.list.3.text'),
                },
            ],
        },
        cookies: {
            title: t('privacy.cookies.title'),
            text: t('privacy.cookies.text'),
            list: [
                {
                    title: t('privacy.cookies.list.0.title'),
                    text: t('privacy.cookies.list.0.text'),
                },
                {
                    title: t('privacy.cookies.list.1.title'),
                    text: t('privacy.cookies.list.1.text'),
                },
                {
                    title: t('privacy.cookies.list.2.title'),
                    text: t('privacy.cookies.list.2.text'),
                },
                {
                    title: t('privacy.cookies.list.3.title'),
                    text: t('privacy.cookies.list.3.text'),
                },
            ],
        },
        complaints: {
            title: t('privacy.complaints.title'),
            text: t('privacy.complaints.text'),
            list: [
                {
                    title: t('privacy.complaints.list.0.title'),
                    text: t('privacy.complaints.list.0.text'),
                },
                {
                    title: t('privacy.complaints.list.1.title'),
                    text: t('privacy.complaints.list.1.text'),
                },
            ],
        },
    };
};

export const getTermsData = t => {
    return {
        intro: {
            title: t('terms.intro.title'),
            text: t('terms.intro.text'),
        },
        acceptance: {
            title: t('terms.acceptance.title'),
            text: t('terms.acceptance.text'),
            list: [
                {
                    title: t('terms.acceptance.list.0.title'),
                    text: t('terms.acceptance.list.0.text'),
                },
            ],
        },
        serviceDescription: {
            title: t('terms.serviceDescription.title'),
            text: t('terms.serviceDescription.text'),
            list: [
                {
                    title: t('terms.serviceDescription.list.0.title'),
                },
                {
                    title: t('terms.serviceDescription.list.1.title'),
                },
                {
                    title: t('terms.serviceDescription.list.2.title'),
                },
                {
                    title: t('terms.serviceDescription.list.3.title'),
                },
            ],
        },
        registration: {
            title: t('terms.registration.title'),
            text: t('terms.registration.text'),
            list: [
                {
                    title: t('terms.registration.list.0.title'),
                },
            ],
        },
        responsibilities: {
            title: t('terms.responsibilities.title'),
            text: t('terms.responsibilities.text'),
            list: [
                {
                    title: t('terms.responsibilities.list.0.title'),
                },
                {
                    title: t('terms.responsibilities.list.1.title'),
                },
                {
                    title: t('terms.responsibilities.list.2.title'),
                },
            ],
        },
        payments: {
            title: t('terms.payments.title'),
            text: t('terms.payments.text'),
            list: [
                {
                    title: t('terms.payments.list.0.title'),
                },
                {
                    title: t('terms.payments.list.1.title'),
                },
                {
                    title: t('terms.payments.list.2.title'),
                },
            ],
        },
        prohibited: {
            title: t('terms.prohibited.title'),
            text: t('terms.prohibited.text'),
            list: [
                {
                    title: t('terms.prohibited.list.0.title'),
                },
            ],
        },
        liability: {
            title: t('terms.liability.title'),
            text: t('terms.liability.text'),
            list: [
                {
                    title: t('terms.liability.list.0.title'),
                },
                {
                    title: t('terms.liability.list.1.title'),
                },
                {
                    title: t('terms.liability.list.2.title'),
                },
            ],
        },
        termination: {
            title: t('terms.termination.title'),
            text: t('terms.termination.text'),
            list: [
                {
                    title: t('terms.termination.list.0.title'),
                },
            ],
        },
        contacts: {
            title: t('terms.contacts.title'),
            text: t('terms.contacts.text'),
            list: [
                {
                    title: t('terms.contacts.list.0.title'),
                    text: t('terms.contacts.list.0.text'),
                },
                {
                    title: t('terms.contacts.list.1.title'),
                    text: t('terms.contacts.list.1.text'),
                },
                {
                    title: t('terms.contacts.list.2.title'),
                    text: t('terms.contacts.list.2.text'),
                },
            ],
        },
    };
};
